import React, { useState, useEffect } from 'react';
import SignaturePad from './SignaturePad';
import { addTextAndSignatureToPDF } from './ModifyPdf';
import { logError } from '../api';
import { validateDniSoft } from '../utils/dniUtils';

const SignatureModal = ({ pdfData,  onClose, onPdfGenerated }) => {
  const [dni, setDni] = useState('');
  const [dniError, setDniError] = useState(null);
  const [signature, setSignature] = useState(null);
  const [isDniSubmitted, setIsDniSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Para mantener el PDF firmado en memoria
  const [signedPdfBlob, setSignedPdfBlob] = useState(null);

  useEffect(() => {
    const byteCharacters = atob(pdfData); // Decodificar base64 a bytes
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    setSignedPdfBlob(blob); // Guardar el PDF original
  }, [pdfData]);

  const handleDniSubmit = () => {
    if (!dni) {
      alert('Por favor, introduce un DNI válido.');
      return;
    }
    const error = validateDniSoft(dni);
    if (error) {
      setDniError(error);
      return;
    }
    setIsDniSubmitted(true);
  };

  // Función para manejar el evento de presionar la tecla Enter
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleDniSubmit(); // Llama a la función de envío del DNI cuando se presiona Enter
    }
  };

  // Función para modificar el PDF y mantenerlo en memoria
  const handleModifyPdf = async () => {
    if (!signature) {
      alert('Por favor, firme antes de continuar.');
      return;
    }
  
    setIsLoading(true);
  
    try {
      // Modificar el PDF original añadiendo la firma
      const modifiedPdf = await addTextAndSignatureToPDF(pdfData, dni, signature);
  
      // Asegúrate de que el PDF modificado es un archivo binario válido
      const pdfBlob = new Blob([modifiedPdf], { type: 'application/pdf' });
      setSignedPdfBlob(pdfBlob);  // Guardamos el PDF firmado en memoria

      // Llamamos a la función onPdfGenerated para que el componente principal pueda manejar el PDF generado
      onPdfGenerated(pdfBlob);
      onClose();
    } catch (error) {
      logError(error);
      console.error('Error al generar el PDF con firma:', error);
      alert('Hubo un error al generar el PDF.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal" style={modalStyles}>
      <div className="modal-content" style={modalContentStyles}>
        <span className="close" onClick={onClose} style={closeButtonStyles}>&times;</span>

        {!isDniSubmitted ? (
          <div>
            <h2>Introduce tu DNI para continuar</h2>
            <input
              type="text"
              value={dni}
              onChange={(e) => { setDni(e.target.value); setDniError(null); }}
              onKeyDown={handleKeyDown}
              placeholder="Introduce tu DNI"
              style={{ ...inputStyles, borderColor: dniError ? '#dc3545' : '#ccc' }}
            />
            {dniError && (
              <p style={{ color: '#dc3545', margin: '4px 0 8px', fontSize: '14px' }}>{dniError}</p>
            )}
            <button onClick={handleDniSubmit} style={buttonStyles}>Enviar DNI</button>
          </div>
        ) : (
          <div>
            <h2>Firma el documento</h2>
            <SignaturePad onSave={(signatureDataUrl) => setSignature(signatureDataUrl)} />
            <button onClick={handleModifyPdf} disabled={isLoading} style={buttonStyles}>
              {isLoading ? 'Generando PDF...' : 'Firmar Albarán'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

// Estilos en línea para el modal
const modalStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.5)',
  zIndex: 1000,
};

const modalContentStyles = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  minWidth: '300px',
  textAlign: 'center',
};

const closeButtonStyles = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  fontSize: '24px',
  cursor: 'pointer',
};

const inputStyles = {
  padding: '10px',
  width: '80%',
  margin: '10px 0',
  borderRadius: '4px',
  border: '1px solid #ccc',
};

const buttonStyles = {
  backgroundColor: '#007bff',
  color: '#fff',
  padding: '10px 20px',
  borderRadius: '5px',
  border: 'none',
  cursor: 'pointer',
  fontSize: '16px',
  marginTop: '10px',
};

export default SignatureModal;
